import React from 'react'
import '../styles/style.css'
import back from '../images/back.svg'
import list from '../images/list.svg'
import info from '../images/delete.svg'
import small from '../images/meditation.svg'
import clock from '../images/timeSmall.svg'
import { getContentHeaders, getGetApi,getPostApi } from '../common/axiosConfig'
import apiUrls from '../common/apiUrls'
import { FRONT_END_NAME } from '../common/constants'
import Empty from './empty'
import Loader from '../common/loader'

class MyList extends React.Component {

    constructor(props){
        super(props);
        this.state={
            showLoader:false,
            myList : [],
            isDeleting : false,
            deleteCount : 0
        }
    }

    goBack = () =>{
        this.props.history.goBack()
    }

    componentDidMount = ()=>{
        this.getMyPersonalizedList();
    }

    showLoader = () => {
        this.setState({ showLoader: true });
    }
    hideLoader = () => {
        this.setState({ showLoader: false });
    }

    getMyPersonalizedList = () =>{
        this.showLoader();
        getGetApi(apiUrls.userplaylist, getContentHeaders()).then((response) => {
            if (response.data.code == 2000) {
               console.log("personalisedlist",response.data.data.content);
               this.setState({myList:response.data.data.content});
                this.hideLoader();
            }
            else if(response.data.code == 2004){
                this.setState({myList:[]});
                this.hideLoader();
            }

        })
    }

    toggleForDelete = (index) =>{
        var myList = this.state.myList;
        var toBeMarked = myList[index];
        toBeMarked.isDeleting = !toBeMarked.isDeleting;
        myList[index] = toBeMarked;
        var deleteCount = myList.filter((a)=>{return a.isDeleting;}).length;
        this.setState({deleteCount,myList});

    }

    playVideo = (item) => {
        item["feed"] = item["content_url"];
        item["filepathurl"] = item["content_url"];
        this.props.history.push({ pathname: FRONT_END_NAME + "/videoplay", state: { video: item } })
       

    }

    startDelete = () =>{
        if(this.state.isDeleting && this.state.deleteCount > 0){
            this.removeFromMyList();
        }
        else {
            this.setState({isDeleting:!this.state.isDeleting});
        }
        //this.setState({isDeleting : true});
    }

    removeFromMyList = () =>{
        var myList = this.state.myList.filter((a)=>{return a.isDeleting;});
        for(var i=0; i<myList.length; i++){
            //debugger;
            this.showLoader();
            var requestBody = {
                "contentId": myList[i].contentId, //required
                
            }
            getPostApi(apiUrls.deleteUserPlaylist, getContentHeaders(), requestBody).then((response) => {
                if (response.data.code == 2000) {
                   
                    this.hideLoader();
                    var newList = this.state.myList.filter((a)=>{return !a.isDeleting;});
                    this.setState({myList:newList});
                    
                }
    
            })
        }
    }


    render() {
        const {myList} = this.state;
        return (
            <div className="container-bmi">
                {this.state.showLoader && <Loader></Loader>}
                <div className="header-bmi ee" >
                    <img src={back} onClick={this.goBack}></img>
                    {/* <img src={list} onClick={this.startDelete}></img> */}
                    <p>My List</p>
                    {myList.length > 0 && <div className="del-divv">
                        {this.state.isDeleting && <p>{this.state.deleteCount} selected</p>}
                        <img src={info} onClick={this.startDelete}></img>
                    </div>}
                </div>
                <div className="content-ml">
                    {myList.length == 0 && <Empty  categoryName={"My List"}></Empty>}
                    {

                    myList && myList.length > 0 && myList.map((item,index)=>
                    <div className="ml-item" key={index}>
                        <div className="ml-item-left">
                            {this.state.isDeleting && <div className="ml"  onClick={()=>{this.toggleForDelete(index)}}>
                                <label className="check-box" onClick={()=>{this.toggleForDelete(index)}}>
                                    <input type="checkbox" name="check-box" onClick={()=>{this.toggleForDelete(index)}} />
                                    <span className="checkbox-checkmark"></span>
                                </label>
                            </div>}
                            <div className="ml-2" style={{backgroundImage:`url(${item.previewImageURL})`}}>

                            </div>
                            
                        </div>
                        <div className="ml-item-right">
                            <div className="ml-3">
                                <p className="p-1">{item.contentTitle}</p>
                                <p className="p-2">
                                    <span><img src={item.categoryImageURL}></img></span>
                                    <span>{item.description}</span>
                                </p>
                                <p className="p-3">
                                    <span><img src={clock}></img></span>
                                    <span>{item.duration}</span>
                                </p>
                            </div>
                            <img src={list} className="ml-3-img" onClick={()=>this.playVideo(item)}></img>
                        </div>
                    </div>
                    )}
                    
                </div>
            </div>
        );
    }
}

export default MyList;
